namespace SorAraBul.Definitions {
    export class OccupationColumns {
        static columnsKey = 'Definitions.Occupation';
    }
}
